// @flow

import { GET_INVOICES } from '../invoice/invoice.const.js';
import { GET_TRANSACTIONS } from '../transaction/transaction.const.js';

export const organization = (state: $ElementType<ReduxState, 'organization'> = {}) => state;

export const organizations = (
  state: $ElementType<ReduxState, 'organizations'> = {},
  action: Action
) => {
  switch (action.type) {
    case GET_INVOICES:
      return {
        ...state,
        ...action.payload.organizations
      };
    case GET_TRANSACTIONS:
      return {
        ...state,
        ...action.payload.organizations
      };
    default:
      return state;
  }
};
